import { render, staticRenderFns } from "./IdentityInformation.vue?vue&type=template&id=1273983b&"
import script from "./IdentityInformation.vue?vue&type=script&lang=js&"
export * from "./IdentityInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports